import { AddItemToWishlistCommand, CartModel, RemoveItemFromWishlistCommand, SkuResult, WishlistModel } from "@core/services/api.service";


export class AddItemToWishListAction {
    static readonly type = '[WishList] Add Item To WishList';

    constructor(public payload: { command: AddItemToWishlistCommand}) {}
}

export class AddItemToWishListSuccessAction {
    static readonly type = '[WishList] Add To Wishlist Success Action';

    constructor(public payload: { WishlistModel: WishlistModel }) { }
}

export class AddItemToWishListFailAction {
    static readonly type = '[WishList] Add To Wishlist Fail Action';

    constructor(public payload: { response: string }) { }
}

// export class EditWishListItemAction {
//     static readonly type = '[WishList] Edit WishList Item Action';

//     constructor(public payload: { wishlistItem: SkuResult}) {}
// }

export class RemoveItemFromWishListAction {
    static readonly type = '[WishList] Remove Item From WishList Action';

    constructor(public payload: { command: RemoveItemFromWishlistCommand}) {}
}

export class RemoveItemFromWishListSuccessAction {
    static readonly type = '[WishList] Remove WishList Items Success Action';

    constructor(public payload: { wishlistItem: WishlistModel }) { }
}

export class RemoveItemFromWishListFailAction {
    static readonly type = '[WishList] Remove WishList Items Fail Action';
}

export class ClearItemsFromWishListAction {
    static readonly type = '[WishList] Clear WishList Action';
}

export class ClearItemsFromWishListSuccessAction {
    static readonly type = '[WishList] Clear WishList Items Success Action';

    constructor(public payload: { result: boolean }) { }
}

export class ClearItemsFromWishListFailAction {
    static readonly type = '[WishList] Clear WishList Items Fail Action';
    constructor(public payload: { response: string }) { }
}

export class LoadWishListAction {
    static readonly type = '[WishList] Load WishList Items Action';
}

export class LoadWishListSuccessAction {
    static readonly type = '[WishList] Load WishList Items Success';

    constructor(public payload: {WishlistModel: WishlistModel }) { }
}

export class LoadWishListFailAction {
    static readonly type = '[WishList] Load WishList Items Fail';

    constructor(public payload: { response: string }) { }
}

export class ClearWishListStateAction {
    static readonly type = '[WishList] Clear WishList Items Fail Action';
   // constructor(public payload: { response: string }) { }
}
